import type { HTMLComponent } from "@commercekit/react";
import type { KlaviyoEmbedFormSliceDefault } from "prismicio-types";

const KlaviyoEmbedFormDefault: HTMLComponent<{
  slice: KlaviyoEmbedFormSliceDefault;
  formId: string;
}> = ({ slice, formId }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="klaviyo-embed-form">
      <div
        key={formId}
        className={`klaviyo-form-${formId} klaviyo-embed-form__form`}
        suppressHydrationWarning
      />
    </section>
  );
};

export default KlaviyoEmbedFormDefault;
